module.exports = __webpack_public_path__ + "img/v3.00e8a762.jpg";